import { useEffect, useRef } from 'react';
import { t } from '../i18n';

/**
 * On every screen change: sets the browser tab title, scrolls to the top and moves
 * focus to the page heading, so a screen reader announces where the person landed.
 */
export function usePageTitle(title: string) {
  const ref = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    document.title = `${title} · ${t('app.titleSuffix')}`;
    window.scrollTo?.(0, 0);
    ref.current?.focus({ preventScroll: true });
  }, [title]);
  return ref;
}
